module.exports = __webpack_public_path__ + "media/icons/offer-details-4x4-d9d05963.png";